import { ExamType, Snippet } from 'types';

/* eslint-disable import/prefer-default-export */
export enum ExamStatusUppercase {
  Unenrolled = 'UNENROLLED',
  Unscheduled = 'UNSCHEDULED',
  Scheduled = 'SCHEDULED',
  Completed = 'COMPLETED',
  RetakeAvailable = 'RETAKE_AVAILABLE',
  RetakeScheduled = 'RETAKE_SCHEDULED',
  RetakeComplete = 'RETAKE_COMPLETE',
  Requested = 'REQUESTED',
  ResultsPending = 'RESULTS_PENDING',
  RetakeResultsPending = 'RETAKE_RESULTS_PENDING',
}

export enum ExamStatus {
  Unenrolled = 'unenrolled',
  Unscheduled = 'unscheduled',
  Scheduled = 'scheduled',
  Completed = 'completed',
  RetakeAvailable = 'retake_available',
  RetakeScheduled = 'retake_scheduled',
  RetakeComplete = 'retake_complete',
  Requested = 'requested',
  ResultsPending = 'results_pending',
  RetakeResultsPending = 'retake_results_pending',
}

export type ExamReadinessInfo = {
  checklist: {
    [version: string]: {
      info: {
        body: string;
        content_type: string;
      };
      doc_type: string;
      code: string;
      language: string;
      objectives: {
        body: string;
        content_type: string;
      };
      version: string;
      epoch_number?: number;
      doc_id: string;
      '@timestamp': string;
    }[];
  };
  checklist_complete: {
    comprehensive_reviews: {
      parent_id: string;
      completed: boolean;
      slug: string;
      page: string;
      course_title: {
        [language: string]: string;
      };
      chapter_title: {
        [language: string]: string;
      };
    }[];
    preliminary_exam: {
      completed: boolean;
      slug: string;
    }[];
    course: {
      completed: boolean;
      slug: string;
      course_title: {
        [language: string]: string;
      };
    }[];
    objectives: {
      slug_page: {
        chapter_title: {
          [language: string]: string;
        };
        course_title: {
          [language: string]: string;
        };
        completed: boolean;
        slug: string;
        page: string;
      }[];
      title: {
        [language: string]: string;
      };
    }[];
    version: string;
  }[];
  readiness_training: {
    completed: boolean;
    slug: string;
  }[];
};

export type ExamCollateral = {
  doc_id?: string;
  doc_type?: string;
  '@timestamp'?: string;
  code?: string;
  language?: string;
  title?: string;
  products?: string[];
  categories?: string[];
  modalities?: string[];
  certification_paths?: string[];
  exam_type?: ExamType;
  preparation?: Snippet;
  exam_format?: Snippet;
  score_and_reporting?: Snippet;
  next_steps?: Snippet;
  prerequisites?: Snippet;
  description?: Snippet;
  objectives?: Snippet;
  audience?: Snippet;
};

// should this have a dedicated file?
export type UserExamDocType = 'user_exam' | 'user_exam_experience';

export type UserExam = {
  doc_id?: string;
  doc_type?: UserExamDocType | string;
  '@timestamp'?: string;
  exam_slug: string;
  exam_sku?: string;
  exam_code?: string;
  username?: string;
  status?: ExamStatus | string;
  exam_date?: string;
  retake_date?: string;
  scheduled_date?: string;
  slug?: string;
  sku?: string;
  order_number?: string;
  subscription_id?: string;
  retake_index?: number;
};
